import { array } from 'fp-ts';
import { DateTimeLocalizationInfo, Time, TimeService } from '@mews/framework';
import { padStartZero } from '@optimus-web/core';

export interface Option {
    time: Time;
    value: string;
    offsetFromStart?: number;
}

export const createLocalizedHours = (localizationInfo: DateTimeLocalizationInfo): Option[] =>
    array.makeBy(24, (item) => {
        const time = TimeService.parse(`${padStartZero(item)}:00:00`);
        const value = TimeService.toShortString(time, localizationInfo);
        return { time, value };
    });
